export default __webpack_public_path__ + "static/ogg-book-87844fdf1474358b3748f6585abf0b65.woff2";